import { useEffect } from 'react';
import seo from '../data/seo.json';

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export default function useSeo(path, override) {
  const page = override || seo.pages[path];
  useEffect(() => {
    if (!page) return;
    document.title = page.title;
    setMeta('meta[name="description"]', 'content', page.description);
    setMeta('meta[property="og:title"]', 'content', page.title);
    setMeta('meta[property="og:description"]', 'content', page.description);
    setMeta('meta[property="og:url"]', 'content', seo.site + path);
    setMeta('link[rel="canonical"]', 'href', seo.site + path);
  }, [path, page?.title]);
}
